import React from "react";
import { FaAlignJustify } from "react-icons/fa";

const DurgaSaiPrasad = () => {
  const styles = {
    body: {
      color: "#666666",
      background: "gainsboro",
      fontFamily: "'Open Sans', sans-serif",
      minHeight: "100vh",
    },
    wrapper: {
      margin: "0 auto",
      maxWidth: "1140px",
      padding: "15px",
    },
    header: {
      background: "#ffffff",
      marginTop: "20px",
      display:"flex",
      justifyContent:"space-between"
    },
    headerInner: {
      padding: "80px 30px",
      minHeight: "330px",
      backgroundPosition: "right bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
    },
    headerP: {
      color: "#FF6F61",
      fontSize: "22px",
      fontWeight: "600",
      marginBottom: "10px",
    },
    headerH1: {
      color: "#222222",
      fontSize: "30px",
      fontWeight: "700",
      marginBottom: "15px",
    },
    typedText: {
      fontSize: "16px",
      lineHeight: "1.6",
      marginTop: "10px",
    },
    section: {
      padding: "60px 30px",
      background: "#ffffff",
      borderBottom: "30px solid gainsboro",
    },
    contentHeader: {
      position: "relative",
      marginBottom: "30px",
      paddingBottom: "10px",
    },
    contentHeaderH2: {
      color: "#222222",
      fontSize: "35px",
      fontWeight: "700",
      letterSpacing: "3px",
      margin: "0",
    },
    underline: {
      position: "absolute",
      width: "50px",
      height: "3px",
      background: "#FF6F61",
      bottom: "0",
      left: "0",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "20px",
    },
    eduCol: {
      padding: "20px",
      borderLeft: "3px solid #FF6F61",
      borderRadius: "4px",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
      background: "#fafafa",
      transition: "0.3s",
    },
    coreTitle: {
      fontWeight: "600",
      color: "#222222",
      marginBottom: "10px",
    },
    experienceTitle: {
      color: "#000",
      marginTop: "10px",
      marginBottom: "8px",
    },
    degreeList: {
      paddingLeft: "0",
      listStyle: "none",
      marginTop: "20px",
    },
    degreeListItem: {
      display: "flex",
      alignItems: "flex-start",
      margin: "12px 0",
      gap: "12px",
      lineHeight: "1.6",
    },
    highlight: {
      color: "#FF6F61",
      fontWeight: "600",
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.wrapper}>
        {/* HEADER */}
        <div style={styles.header}>
          <div style={{
            ...styles.headerInner,
          }}>
            <p style={styles.headerP}>I'm</p>
            <h1 style={styles.headerH1}>Durga Sai Prasad G</h1>
            <div style={styles.typedText}>
              Full Stack Development, Mobile Application Development.
            </div>
            <div style={styles.typedText}>
              ReactJS, NextJs, Bootstrap, GSAP, Node, ExpressJs, MongoDB, React Native and AWS
            </div>
          </div>
          <div>
            <img src="https://adityauniversity.in/adtppu/SDG/DSP.png" width={"300px"} />
          </div>
        </div>

        {/* ABOUT */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>About Me</h2>
            <div style={styles.underline}></div>
          </div>
          <p>
            I am a proficient Full Stack Developer with experience in building scalable web and mobile applications using React.js, Node.js, React Native, and MongoDB. I specialize in crafting clean, efficient, and reliable solutions with a strong focus on performance and user experience. I hold certifications as a MongoDB Associate Developer, IT Specialist in JavaScript, and AWS Cloud, demonstrating a solid foundation in modern development practices and continuous learning.
          </p>
        </div>

        {/* CORE COMPETENCIES */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>Core Competencies</h2>
            <div style={styles.underline}></div>
          </div>
          <div style={styles.grid}>
            {[
              {
                title: "Front-End Development",
                desc: "Proficient in building responsive and dynamic user interfaces using React.js, HTML5, CSS3, JavaScript (ES6+), and modern UI frameworks like Tailwind and Bootstrap.",
              },
              {
                title: "Back-End Development",
                desc: "Expertise in developing scalable server-side applications using Node.js, Express.js, REST APIs, and implementing secure authentication & authorization flows.",
              },
              {
                title: "React Native Development",
                desc: "Proficient in building high-performance cross-platform mobile applications using React Native, with strong expertise in UI development, state management, API integration, and app deployment for both Android and iOS.",
              },
              {
                title: "MongoDB Development",
                desc: "Skilled in designing efficient database schemas, building optimized queries, managing indexes, and leveraging the aggregation framework to deliver scalable, high-performance MongoDB solutions for modern applications.",
              },
              {
                title: "Professional Certifications",
                desc: "Certified as a MongoDB Associate Developer and IT Specialist in JavaScript, with additional AWS Cloud certification, demonstrating strong expertise in modern backend development, programming fundamentals, and cloud technologies.",
              },
            ].map((item, index) => (
              <div key={index} style={styles.eduCol}>
                <h5 style={styles.coreTitle}>{item.title}</h5>
                <p style={{textAlign:"justify"}}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* PROFESSIONAL EXPERIENCE */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>Professional Experience</h2>
            <div style={styles.underline}></div>
          </div>
          <h5 style={styles.experienceTitle}>Lecturer and Developer, Full Stack Development</h5>
          <h5 style={styles.experienceTitle}>Aditya University – Kakinada, Andhra Pradesh</h5>
          <h5 style={styles.experienceTitle}>March 2023 – Present</h5>

          <ul style={styles.degreeList}>
            {[
              "Teach core Full Stack Development technologies including React.js, Node.js, Express.js, MongoDB, and React Native to undergraduate and postgraduate students.",
              "Develop and deliver structured curriculum covering front-end development, backend APIs, database design, and mobile application development",
              "Conduct workshops on version control (Git/GitHub), REST API development, and database best practices with MongoDB.",
              "Guide students through real-world projects, helping them build responsive UIs, scalable backend services, and high-performance mobile applications.",
              "Evaluate student progress, conduct code reviews, and provide personalized mentoring to strengthen problem-solving and coding proficiency.",
              "Mentor students on full-stack capstone projects, focusing on API integration, database modeling, cloud deployment, and application optimization.",
            ].map((item, index) => (
              <li key={index} style={styles.degreeListItem}>
                <img
                  src="data:image/png;base64,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"
                  alt="bullet"
                  style={{ height: "10px", marginTop: "7px", flexShrink: 0 }}
                />
                <p style={{ margin: 0 }}>{item}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* KEY ACHIEVEMENTS */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>Key Achievements</h2>
            <div style={styles.underline}></div>
          </div>
          <p>Successfully trained and mentored over 2500+ students in Full Stack Development, enabling many to build complete web and mobile applications.</p>
          <p>Designed and delivered a comprehensive full stack curriculum covering React.js, Node.js, MongoDB, Express.js, and React Native, improving student project quality and technical proficiency.</p>
          <p>Implemented hands-on project-based learning methods that improved student understanding of APIs, database modeling, and cloud deployment.</p>
          <p>Recognized by the department for delivering high-quality instruction and consistently achieving excellent student feedback scores.</p>
        </div>

        {/* CERTIFICATIONS */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>Certifications</h2>
            <div style={styles.underline}></div>
          </div>
          <div style={styles.grid}>
            {[
              "Associate Developer – MongoDB",
              "Cloud Practitioner – AWS",
              "IT Specialist JavaScript – Certiport",
              "IT Specialist HTML & CSS – Certiport",
            ].map((cert, index) => (
              <p key={index}>{cert}</p>
            ))}
          </div>
        </div>

        {/* TECHNICAL SKILLS */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>Technical Skills</h2>
            <div style={styles.underline}></div>
          </div>
          <p>
            <span style={styles.highlight}>Front-End:</span> React.js, JavaScript (ES6+), HTML5, CSS3, Tailwind CSS, Bootstrap
          </p>
          <p>
            <span style={styles.highlight}>Back-End:</span> Node.js, Express.js, REST API Development, Authentication & Authorization
          </p>
          <p>
            <span style={styles.highlight}>Mobile Development:</span> React Native, Expo, Android & iOS Deployment, State Management (Redux, Context API)
          </p>
          <p>
            <span style={styles.highlight}>Database:</span> MongoDB, Mongoose, Schema Design, Aggregation Pipeline
          </p>
          <p>
            <span style={styles.highlight}>DevOps & Cloud:</span> AWS (EC2, S3), Docker, GitHub Actions, CI/CD, Nginx, PM2
          </p>
        </div>

        {/* PROFESSIONAL DEVELOPMENT */}
        <div style={styles.section}>
          <div style={styles.contentHeader}>
            <h2 style={styles.contentHeaderH2}>Professional Development</h2>
            <div style={styles.underline}></div>
          </div>
          <p>
            Actively engaged in continuous learning through advanced workshops and online programs focused on Full Stack Development, React Native, and MongoDB. Participated in hands-on training sessions covering modern backend architecture, API design, cloud deployment on AWS, and mobile app optimization. Regularly attend industry webinars, developer conferences, and community meetups to stay updated on the latest trends, frameworks, and best practices in web and mobile development.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DurgaSaiPrasad;